<template>
    <ViewOffre/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewOffre from "@/components/Offre/ViewOffre.vue";

    export default defineComponent({
      name: "ViewOffrePage",
      components: {
        
        ViewOffre,
      },
    });
  </script>